import moment from 'moment';

moment.defaultFormat = 'lll';

export default moment;
